<div style="margin: 10px 0px 20px 0px">
  <a routerLink="/articles" mat-stroked-button aria-label="Back to All Articles">
    <mat-icon>arrow_back</mat-icon>
    Back to All Articles
  </a>
</div>
@if (articleId) {
  @if (articleService.getArticleUrl(articleId) | async; as url) {
    <p style="font-style: italic; font-size: small">Published: {{ articleService.getArticleCreatedDate(articleId) | async | date: 'fullDate' : 'UTC' }}</p>

    @if ((articleService.getArticleCreatedDate(articleId) | async | date: 'fullDate' : 'UTC') !== (articleService.getArticleUpdatedDate(articleId) | async | date: 'fullDate' : 'UTC')) {
      <p style="font-style: italic; font-size: small">Last Update: {{ articleService.getArticleUpdatedDate(articleId) | async | date: 'fullDate' : 'UTC' }}</p>
    }
    <p style="font-size: small">Writen by {{ articleService.getArticleAuthor(articleId) | async }}</p>
    <markdown style="width: 100%" [src]="url"> </markdown>
  } @else {
    <p>Loading...</p>
  }
} @else {
  <p>No article selected</p>
}
<div style="margin: 10px 0px 20px 0px">
  <a routerLink="/articles" mat-stroked-button aria-label="Back to All Articles">
    <mat-icon>arrow_back</mat-icon>
    Back to All Articles
  </a>
</div>
